module.exports = __webpack_public_path__ + "static/media/ashutosh.4d892f35.jpg";